import React, { useMemo, useState } from "react";

import { Badge, EmptyState, Table } from "../../../Ui/index.jsx";
import { AdminTab, TabLoading } from "./adminShared.jsx";

// A superadmin viewing the app as someone else goes through the same Django login path as a real sign-in, so
// those rows used to be indistinguishable from that person actually signing in. They're labelled now — the row
// reads "bassi → Karishmajoshi" rather than looking like Karishma logged in herself.
const EVENT_LABEL = { login: "login", failed: "failed", login_as: "login as", exit_login_as: "exit login as" };
const EVENT_HINT = {
  login_as: "A superadmin started viewing the app as this user — not a real sign-in by them.",
  exit_login_as: "A superadmin stopped viewing as another user and returned to their own account.",
};
const EVENT_TONE = { login: "success", failed: "danger", login_as: "warning", exit_login_as: "warning" };

export function LoginActivityTab({ audit }) {
  const [sort, setSort] = useState({ key: "at", dir: "desc" });
  const rows = useMemo(() => [...(audit || [])].sort((a, b) => {
    const c = String(a[sort.key] || "").localeCompare(String(b[sort.key] || ""));
    return sort.dir === "asc" ? c : -c;
  }), [audit, sort]);
  if (!audit) return <TabLoading />;
  const onSort = (key) => setSort((cur) => ({ key, dir: cur.key === key && cur.dir === "asc" ? "desc" : "asc" }));
  const columns = [
    { key: "username", header: "User", sortable: true, className: "is-card-title", render: (a) => <span className="ds-strong">{a.username || "—"}</span> },
    { key: "event", header: "Event", sortable: true, className: "is-card-amount", render: (a) => <Badge variant={EVENT_TONE[a.event]} title={EVENT_HINT[a.event] || ""}>{EVENT_LABEL[a.event] || a.event}</Badge> },
    { key: "ip", header: "IP", sortable: true, className: "ds-small", render: (a) => a.ip || "—" },
    { key: "at", header: "When", sortable: true, align: "right", className: "ds-small", render: (a) => new Date(a.at).toLocaleString() },
  ];
  return (
    <AdminTab title="Login activity" subtitle={`${audit.length} in total`}>
      {!audit.length ? <EmptyState>Nothing yet — captured on the next login after deploy.</EmptyState> : (
        <Table stack columns={columns} rows={rows.map((a, i) => ({ ...a, id: i }))} sort={sort} onSort={onSort} />
      )}
    </AdminTab>
  );
}
